/**
 * Main entry point for the bundled script of the admin plugin
 */
import ui from "./src/ui";

// Include styling files to ensure it is included in the build
require('../style/main.scss');

// Initialize the UI (includes porto theme initialization)
ui.initialize();



// WEBPACK FOOTER //
// ./build/script/main.js